import React, { useEffect, useRef, useState } from 'react';
import { FaPowerOff, FaUser } from 'react-icons/fa';
import { HiHome } from 'react-icons/hi';
import { useLocation, useNavigate } from 'react-router-dom';
import { getUserName, getUserRole } from '../../utils/localStoarege';

function ClinicProfileDropdown({ logout }) {
    const [userName, setUserName] = useState("");
    const [role, setRole] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null); // Use ref to track dropdown
    const navigate = useNavigate();

    const location = useLocation();
    const [rowData, setRowData] = useState({});

    useEffect(() => {
        if (location.state) {
            setRowData(location.state);
        }
        setUserName(getUserName());
        setRole(getUserRole());
    }, [location]);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleLogout = () => {
        setIsDropdownOpen(false); // Close dropdown after logging out
        logout();
    };

    const handleHistory = () => {
        setIsDropdownOpen(false); // Close dropdown after navigating to history
        navigate('/account');
    };

    // Close dropdown if clicking outside of it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="relative">
            <div
                className="flex items-center space-x-1 text-white fill-primary cursor-pointer gap-1 max-w-40 text-center"
                onClick={toggleDropdown}
            >
                <HiHome /> {role === "operator" ? (userName ?? "") : role.toLocaleUpperCase()}
            </div>

            {isDropdownOpen && (
                <div
                    className="absolute right-0 mt-2 w-52 bg-[#F4FAF1]"
                    ref={dropdownRef}
                >
                    {/* <button
                        className="w-full px-4 py-2 text-left text-black bg-white rounded-xl hover:bg-gray-100 my-2 shadow-lg z-10  flex flex-row items-center gap-2"
                        onClick={handleHistory}
                    >
                        <FaUser />
                        Account Settings
                    </button> */}
                    <button
                        className="w-full px-4 py-2 text-left text-red-600 bg-white rounded-xl hover:bg-gray-100 my-2 shadow-lg z-10 flex flex-row gap-2 items-center"
                        onClick={handleLogout}
                    >
                        <FaPowerOff />
                        Logout
                    </button>
                </div>
            )}
        </div>
    );
}

export default ClinicProfileDropdown;
